import normalizeUrl from './cityDetail/normalizeUniversityUrl';

export const universitySortOptions = [
    { field: 'name', label: 'University name' },
    { field: 'studentsNumber', label: 'Number of students' },
    { field: 'classification', label: 'Classification' },
];

export const emptyUniversityFilters = { classification: '', website: '' };

export const getMobileUniversityResults = (universities, search, filters, sort) => {
    const query = search.trim().toLowerCase();
    const results = universities.filter(university => {
        const matchesSearch = !query || [university.name, university.address, university.url]
            .some(value => String(value || '').toLowerCase().includes(query));
        const matchesClass = !filters.classification || university.classification === filters.classification;
        const hasWebsite = Boolean(normalizeUrl(university.url));
        const matchesWebsite = !filters.website || (filters.website === 'yes' ? hasWebsite : !hasWebsite);
        return matchesSearch && matchesClass && matchesWebsite;
    });
    if (!sort.field) return results;
    const value = university => {
        const raw = university[sort.field];
        if (raw === null || raw === undefined || raw === '') return null;
        if (sort.field === 'studentsNumber') return Number.isFinite(Number(raw)) ? Number(raw) : null;
        return String(raw).trim().toLowerCase();
    };
    return results.sort((a, b) => {
        const left = value(a);
        const right = value(b);
        // Unknown values stay last in either direction.
        if (left === null) return right === null ? 0 : 1;
        if (right === null) return -1;
        const comparison = typeof left === 'number' ? left - right : left.localeCompare(right);
        return sort.direction === 'desc' ? -comparison : comparison;
    });
};
